import React from "react";

export const Asana = ({ className }: { className?: string }) => (
  <svg width="35" height="32" viewBox="0 0 35 32" fill="none" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.9262 16.5955C22.8603 16.5955 19.5643 19.8915 19.5643 23.9577C19.5643 28.0236 22.8603 31.3195 26.9262 31.3195C30.9921 31.3195 34.288 28.0236 34.288 23.9577C34.288 19.8915 30.9921 16.5955 26.9262 16.5955ZM7.79937 16.5962C3.73356 16.5962 0.4375 19.8916 0.4375 23.9577C0.4375 28.0236 3.73356 31.3197 7.79937 31.3197C11.8654 31.3197 15.1616 28.0236 15.1616 23.9577C15.1616 19.8916 11.8654 16.5962 7.79937 16.5962ZM24.7245 7.39297C24.7245 11.4591 21.4286 14.7555 17.3628 14.7555C13.2968 14.7555 10.0009 11.4591 10.0009 7.39297C10.0009 3.32763 13.2968 0.03125 17.3628 0.03125C21.4286 0.03125 24.7245 3.32763 24.7245 7.39297Z"
      fill="#00A972"
    />
  </svg>
);
